import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {
  RoutesViewSettingsModel,
  RoutesViewSettingsRouteModel,
  RoutesViewSettingsRoutesModel
} from "../../models/routes-view-settings.model";

export class RoutesSettingsPanelComponent implements IController {

  showRoutes?: boolean;
  showStops?: boolean;
  routesSettings: RoutesViewSettingsRoutesModel;
  tasksSettings: RoutesViewSettingsRouteModel;
  onSettingsChange: Function;

  constructor(private $mdPanel) {

  }

  onShowPanel($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.OFFSET_START,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.show-button')
      .withAnimation(this.$mdPanel.animation.FADE);

    const routesSettingsRef = this.routesSettings;
    const tasksSettingsRef = this.tasksSettings;

    const showRoutesRef = this.showRoutes;
    const showStopsRef = this.showStops;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<routes-settings-panel-template ' +
        'panel-ref="ctrl.mdPanelRef" routes-settings="ctrl.routesSettings" tasks-settings="ctrl.tasksSettings" ' +
        'show-routes="ctrl.showRoutes" show-stops="ctrl.showStops">' +
        '</routes-settings-panel-template>',
      controller: function () {
        this.routesSettings = routesSettingsRef;
        this.tasksSettings = tasksSettingsRef;
        this.showRoutes = showRoutesRef;
        this.showStops = showStopsRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, reason, updatedSettings: {routesSettings, tasksSettings}) => {

        if (_.isEqual(reason, 'Submit')) {
          this.onSubmit(updatedSettings.routesSettings, updatedSettings.tasksSettings);
        }

        if (_.isEqual(reason, 'Reset')) {
          this.onReset();
        }

        if (_.isEqual(reason, 'Cancel')) {
          this.onReset();
        }

        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onClosePanel(settingsConfig) {
    // this.onSettingsChange({routesSettings: routesSettings, tasksSettings: tasksSettings})
  }

  onSubmit(routesSettings, tasksSettings) {
    this.onSettingsChange({routesSettings: routesSettings, tasksSettings: tasksSettings});
  }

  onReset() {
    // const settingsConfig = this.splitService.getSiteAgentsSettings(this.splitService.getSiteId());
    // this.onSettingsChange({settings: settingsConfig});
  }

  onCancel() {
    this.onSettingsChange({routesSettings: this.routesSettings, tasksSettings: this.tasksSettings});
  }

}

angular
  .module('bringoz.admin.routes')
  .component('routesSettingsPanel', {
    bindings: {
      showRoutes: '<?',
      showStops: '<',
      routesSettings: '<',
      tasksSettings: '<',
      onSettingsChange: '&'
    },
    template: require('./routes-settings-panel.html').default,
    controller: RoutesSettingsPanelComponent
  });
